module.exports = __webpack_public_path__ + "img/background_about.1c79b803.jpeg";